import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    formSubtitle: {
        fontFamily: "Open Sans",
        fontWeight: 600,
        fontSize: "20px",
        color: theme.palette.secondary.dark,
        margin: "0",
    },
    textField: {
        width: "100%",
        height: 56,
        "& .MuiOutlinedInput-root": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Open Sans",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.light,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    listContainer: {
        "&.MuiList-root": {
            paddingTop: 0,
        },
        width: "100%",
    },
    listItem: {
        display: "flex",
        boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.12)",
    },
    listText: {
        "&.MuiListItemText-root .MuiTypography-root": {
            fontFamily: "Open Sans",
            fontSize: "14px",
            color: theme.palette.secondary.dark,
        },
    },
    accordionGroup: {
        width: "100%",
    },
    accordionSummary: {
        "& .MuiAccordionSummary-content": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
    },
    accordionDetails: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(8),
    },
    toggleButtonGroup: {
        borderRadius: 4,
        display: "flex",
        gap: 12,
    },
    toggleButton: {
        width: 24,
        height: 24,
        "&.MuiButtonBase-root.MuiToggleButton-root.Mui-selected": {
            backgroundColor: theme.palette.info.light,
            color: theme.palette.primary.main,
        },
        borderRadius: "100% !important",
        border: "1px solid rgba(0, 0, 0, 0.12) !important",
    },
    timePickersWrapper: {
        display: "flex",
        gap: theme.spacing(2),
        alignItems: "center",
    },
    listTextTitle: {
        width: 0,
        "&.MuiListItemText-root .MuiTypography-root": {
            fontFamily: "Open Sans",
            fontSize: "14px",
            color: theme.palette.secondary.dark,
            textTransform: "capitalize",
        },
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Open Sans",
            paddingBottom: "5px",
        },
    },
    iconsContainer: {
        display: "flex",
    },
    effectiveDateContainer: {
        display: "flex",
        flexDirection: "column",
    },
    overlappingContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    overlappingText: {
        fontWeight: `${700} !important`,
        color: `${theme.palette.error.main} !important`,
    },
    shiftsChipsContainer: {
        display: "flex",
        gap: theme.spacing(1),
        textAlign: "center",
    },
    divisionLine: {
        borderBottom: "1px solid rgba(0, 0, 0, 0.12) !important",
        width: "100%",
    },
    productionLinesList: {
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
    },
    nonOverlappingShift: {
        background: `${theme.palette.graphs.dots} !important`,
        color: `${theme.palette.primary.darker} !important`,
    },
    overlappingShift: {
        background: `${theme.palette.error.main} !important`,
        color: `${theme.palette.primary.main} !important`,
    },
    conflictingTime: {
        "& .MuiInputLabel-formControl": {
            color: `${theme.palette.error.main} !important`,
        },
        "& div.MuiInputBase-colorPrimary fieldset": {
            borderColor: `${theme.palette.error.main} !important`,
        },
    },
    nonConflictingTime: {
        "& .MuiInputLabel-formControl": {
            color: "unset",
        },
        "& div.MuiInputBase-colorPrimary fieldset": {
            borderColor: "unset",
        },
    },
    helperText: {
        fontSize: "10px !important",
        letterSpacing: "0",
        display: "flex",
        flexDirection: "column",
    },
    effectiveAtInfoText: {
        color: theme.palette.info.main,
    },
}));
